import { useCallback, useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FormFuncionarios } from '../../../components/Forms/FormFuncionarios'
import FuncionariosService from '../../../services/database/FuncionariosService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

import { toast } from 'react-toastify'
import './styles.css'

export function ModalEditFunc({ isOpen, onClose, funcId, loadFuncionarios }) {
  const [requestIsLoading, setRequestIsLoading] = useState(false)

  const formFuncionariosRef = useRef(null)

  async function handleSubmit(data) {
    setRequestIsLoading(true)

    try {
      const { id, ...rest } = data

      await FuncionariosService.update(id, rest)

      formFuncionariosRef.current?.resetForm()

      toast.success('Funcionário atualizado com sucesso!')

      await loadFuncionarios()

      onClose()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao editar funcionário!')
    } finally {
      setRequestIsLoading(false)
    }
  }

  const loadFuncionario = useCallback(async () => {
    try {
      const funcionarioData = await FuncionariosService.getById(funcId)

      formFuncionariosRef.current?.setFields(funcionarioData)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível buscar os dados desse usuário!',
      )
    }
  }, [funcId])

  useEffect(() => {
    loadFuncionario()
  }, [loadFuncionario])

  return (
    <Modal
      centered
      dialogClassName="custom-modalzpl"
      show={isOpen}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Funcionário</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormFuncionarios
          ref={formFuncionariosRef}
          onClose={onClose}
          onSubmit={handleSubmit}
          requestIsLoading={requestIsLoading}
          buttonSubmitText="Atualizar"
        />
      </Modal.Body>
    </Modal>
  )
}
